'use strict';

/**
 * This class acts as a wrapper for your input formatter of choice.
 * Using Cleave.js in this case.
 */

import Cleave from 'cleave.js';
import {objectAssign} from '../helpers/utilities';
import {getQueryStringParams} from '../helpers/urlUtilities';
import {callbackOnElements} from '@borngroup/born-utilities';

let customBINs;

const Instances = [],
    CARD_TYPES = {
        visa: 'Visa',
        mastercard: 'Master Card',
        mada: 'Mada',
        amex: 'Amex',
        discover: 'Discover',
        unknown: 'Unknown',
        jcb: 'JCB'
    };

export default class InputFormat {
    constructor(inputs, options = {}) {
        this.options = options;

        callbackOnElements(inputs, this.setupFormatting.bind(this));
    }

    setupFormatting(currentInput) {
        let hasCustomSettings = currentInput.getAttribute('data-input-format'),
            currentInputSettings = objectAssign({}, this.options, hasCustomSettings ? JSON.parse(hasCustomSettings) : {}),
            inputFormat;

        if (!currentInput.hasAttribute('data-disable-formatting')) {
            if (currentInputSettings.creditCard) {
                //Retrieve the available custom BINs for later use.
                InputFormat.getCustomBINs();

                inputFormat = InputFormat.setupCreditCard(currentInput, currentInputSettings);
            } else if (currentInputSettings.phone) {
                inputFormat = InputFormat.setupPhone(currentInput, currentInputSettings);
            } else {
                inputFormat = InputFormat.setupInput(currentInput, currentInputSettings);
            }
        }

        if (inputFormat && !InputFormat.get(currentInput)) {
            Instances.push({input: currentInput, inputFormat});
        }

        currentInput.removeAttribute('data-input-format');
        currentInput.setAttribute('data-input-has-format', true);
    }

    /**
     * Returns the matched format object, where `referenceInput` is the element to be looked up.
     */
    static get(referenceInput) {
        for (let i = 0; i < Instances.length; i++) {
            if (Instances[i].input === referenceInput) {
                return Instances[i].inputFormat;
            }
        }
    }

    static getCustomBINs() {
        if (!customBINs && window.SFRA.SitePreferences.ckoEnabled) {
            return $.get(window.SFRA.Urls.customBINs, function(response) {
                customBINs = response.list;
            });
        }
    }

    static updateMatchingCardData(options) {
        // handling JCB creditcards starting with 33 because cleave.js not recognising this series
        let cardNumber = options.inputField.value.trim();
        let firstTwoDigits = cardNumber.substring(0, 2);
        if (options.type == 'unknown' && firstTwoDigits == '33') {
            options.type = 'jcb';
        }

        let cardTypeLabel = CARD_TYPES[Object.keys(CARD_TYPES).indexOf(options.type) > -1 ? options.type : 'unknown'];

        if (options.cardTypeContainer) {
            options.cardTypeContainer.setAttribute('data-type', options.type);
        }

        if (options.cardTypeInput) {
            options.cardTypeInput.value = cardTypeLabel;
        }

        if (options.cardCVVInput) {
            options.cardCVVInput.maxLength = options.type === 'amex' ? 4 : 3;
        }

        options.inputField.setAttribute('data-submit-format-raw', true);
    }

    static setupCreditCard(inputField, settings) {
        let formContainer = inputField.form || document,
            cardTypeContainer = formContainer.querySelector(settings.cardTypeContainer || '[data-card-type-container]'),
            cardTypeInput = formContainer.querySelector(settings.cardTypeInput || '[data-card-type-input]'),
            cardCVVInput = formContainer.querySelector(settings.cardCVVInput || '[data-card-cvv-input]');

        return new Cleave(inputField, {
            creditCard: true,
            onValueChanged: function(evt) {
                let cardValue = evt.target.rawValue.substring(0, 6),
                    type = this.properties.creditCardType;

                if (cardValue.length >= 6 && customBINs && customBINs.mada && customBINs.mada.indexOf(cardValue) !== -1) {
                    type = 'mada';
                }

                InputFormat.updateMatchingCardData({type, inputField, cardTypeContainer, cardTypeInput, cardCVVInput});
            },
            onCreditCardTypeChanged: function(type) {
                InputFormat.updateMatchingCardData({type, inputField, cardTypeContainer, cardTypeInput, cardCVVInput});
            }
        });
    }

    //import 'cleave.js/src/addons/phone-type-formatter.us.js';
    // static setupPhone(inputField, settings) {
    //     let countrySelector = inputField.form ? inputField.form.querySelector('[name*="country"]') : null,
    //         selectedCountryCode = countrySelector ? countrySelector.value : 'US';

    //     settings.phoneRegionCode = settings.phoneRegionCode || selectedCountryCode;

    //     return new Cleave(inputField, settings);
    // }

    static setupInput(inputField, settings) {
        return new Cleave(inputField, settings);
    }

    static sanitizeFormattedData(formEl, formData, callback) {
        let dataIsSerialized = typeof formData === 'string',
            rawFormatInputs = formEl.querySelectorAll('[data-submit-format-raw]');

        //Convert `formData` to a literal for easy updating.
        formData = dataIsSerialized ? getQueryStringParams(formData) : formData;

        [].forEach.call(rawFormatInputs, function(currentInput) {
            formData[currentInput.name] = InputFormat.get(currentInput).getRawValue();
        });

        //Reset `formData` to its original format.
        formData = dataIsSerialized ? $.param(formData) : formData;

        if (typeof callback === 'function') {
            callback(formData);
        }

        return formData;
    }
}
